import {
  Circle,
  CheckCircle2,
  Loader,
  XCircle,
  Archive,
  FileCheck,
  Tag,
} from "lucide-react";
import type { FilterCategoryGroup } from "@/components/ui";
import type { AuditTag } from "@/packages/types";
import { AUDIT_STATUS_CONFIG } from "./constants";

const BASE_AUDIT_FILTER_CATEGORIES: FilterCategoryGroup[] = [
  {
    label: "Audit Properties",
    categories: [
      {
        id: "status",
        label: "Status",
        icon: Circle,
        allowedOperators: ["is", "is_not", "is_either_of"],
        values: [
          {
            id: "pending",
            label: "Pending",
            icon: Circle,
            color: AUDIT_STATUS_CONFIG.pending.dotColor,
          },
          {
            id: "in_progress",
            label: "In Progress",
            icon: Loader,
            color: AUDIT_STATUS_CONFIG.in_progress.dotColor,
          },
          {
            id: "submitted",
            label: "Submitted",
            icon: FileCheck,
            color: AUDIT_STATUS_CONFIG.submitted.dotColor,
          },
          {
            id: "approved",
            label: "Approved",
            icon: CheckCircle2,
            color: AUDIT_STATUS_CONFIG.approved.dotColor,
          },
          {
            id: "rejected",
            label: "Rejected",
            icon: XCircle,
            color: AUDIT_STATUS_CONFIG.rejected.dotColor,
          },
          {
            id: "archived",
            label: "Archived",
            icon: Archive,
            color: AUDIT_STATUS_CONFIG.archived.dotColor,
          },
        ],
      },
      {
        id: "trigger",
        label: "Trigger",
        icon: Tag,
        allowedOperators: ["is", "is_not", "is_either_of"],
        values: [],
      },
      {
        id: "tags",
        label: "Tags",
        icon: Tag,
        allowedOperators: ["includes_any", "includes_all", "includes_none"],
        values: [],
      },
    ],
  },
];

export { BASE_AUDIT_FILTER_CATEGORIES as AUDIT_FILTER_CATEGORIES };

export function getAuditFilterCategories(
  tags: AuditTag[],
  triggers: string[],
): FilterCategoryGroup[] {
  return BASE_AUDIT_FILTER_CATEGORIES.map((group) => {
    if (group.categories) {
      return {
        ...group,
        categories: group.categories.map((category) => {
          if (category.id === "tags") {
            return {
              ...category,
              values: tags.map((tag) => ({
                id: tag.id,
                label: tag.name,
                color: tag.color,
              })),
            };
          }
          if (category.id === "trigger") {
            return {
              ...category,
              values: triggers.map((t) => ({ id: t, label: t })),
            };
          }
          return category;
        }),
      };
    }
    return group;
  });
}
